<template>
  <v-container
    container--fluid
    grid-list-xl
  >
    <v-card
      v-if="$apollo.loading && !rankings && viewStyle == 0"
    >
      <v-layout
        class="mt-0 mb-0"
      >
        <v-flex
          xs12
          mt-0
          mb-0
          pt-0
          pb-0
          pl-10
          pr-10
        >
          <v-skeleton-loader
            type="table-row"
            :tile="false"
            height="70px"
          />
        </v-flex>
      </v-layout>
      <v-layout
        v-for="(y, x) in params.count"
        :key="x"
        wrap
        align-center
      >
        <v-flex xs3>
          <v-skeleton-loader
            type="list-item-avatar-two-line"
            :tile="false"
          />
        </v-flex>
        <v-flex
          v-for="(o, i) in [1,2,3,4]"
          :key="i"
          xs2
        >
          <v-skeleton-loader
            type="list-item"
            :tile="false"
          />
        </v-flex>
        <v-flex xs1>
          <v-skeleton-loader
            type="button"
            :tile="false"
          />
        </v-flex>
      </v-layout>
    </v-card>
    <v-layout
      v-if="$apollo.loading && !rankings && viewStyle == 1"
      wrap
    >
      <v-flex
        v-for="(y, x) in params.count"
        :key="x"
        xs12
        md4
      >
        <v-card>
          <v-layout
            wrap
            align-center
          >
            <v-flex xs7>
              <v-skeleton-loader
                type="list-item-avatar-two-line"
                :tile="false"
              />
            </v-flex>
            <v-flex
              xs5
            >
              <v-skeleton-loader
                type="text"
                :tile="false"
                width="100px"
              />
            </v-flex>
            <v-flex
              v-for="(o, i) in [1,2,3,4,5,6]"
              :key="i"
              xs4
            >
              <v-skeleton-loader
                type="list-item"
                :tile="false"
              />
            </v-flex>
            <v-flex xs12>
              <v-skeleton-loader
                type="button"
                :tile="false"
                style="float:right;"
              />
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="rankings && viewStyle == 0 && !$vuetify.breakpoint.xs"
      wrap
    >
      <v-flex xs12>
        <v-card>
          <v-data-table
            v-if="rankings"
            class="rankings"
            :headers="headers"
            :items="rankings.data"
            :hide-default-footer="true"
            :mobile-breakpoint="1066"
            :items-per-page="200"
          >
            <template v-slot:header.aum="{ }">
              <span>{{ $t('globals.aum') }}</span>
              <template>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t('rankings.aumTooltip') }}
                </v-tooltip>
              </template>
            </template>
            <template v-slot:header.roi="{ }">
              <span>{{ $t('globals.roi') }}</span>
              <template>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t('rankings.roiTooltip') }}
                </v-tooltip>
              </template>
            </template>
            <template v-slot:header.risk="{ }">
              <span>{{ $t('globals.risk') }}</span>
              <template>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t('globals.riskTooltip') }}
                </v-tooltip>
              </template>
            </template>
            <template v-slot:header.mindeposit="{ }">
              <span>{{ $t('globals.minDeposit') }}</span>
              <template>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t('rankings.minDepositTooltip') }}
                </v-tooltip>
              </template>
            </template>
            <template v-slot:item.rank="{ item }">
              <b>{{ item.rank }}</b>
            </template>

            <template v-slot:item.logo="{ item }">
              <v-avatar
                v-if="item.project.logo !== null"
                :tile="false"
                :size="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm ? 60 : 30"
              >
                <v-img
                  :src="item.project.logo"
                  :lazy-src="item.project.logo"
                  max-height="60"
                  contain
                />
              </v-avatar>
              <v-avatar
                v-else
                style="pointer: cursor"
                :tile="false"
                :size="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm ? 60 : 30"
                color="#eceff1"
              >
                <strong
                  class="avatar-invert"
                >{{ item.project.ticker | uppercase | substring(0,2) }}</strong>
              </v-avatar>
            </template>
            <template v-slot:item.ticker="{ item }">
              <b class="ticker">{{ item.project.ticker }}</b> 
              <v-tooltip
                v-if="item.project.type == 'trading.copy'"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    style="margin: -5px 0px 0px 5px; font-size:18px;"
                    v-on="on"
                  >
                    mdi-alpha-c-circle-outline
                  </v-icon>
                </template>
                {{ $t('rankings.traderSupportCopy') }}
              </v-tooltip>
              <v-tooltip
                v-if="item.project.project_type == 'bot'"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    style="margin: -7px 0px 0px 4px; font-size:18px; color:#bcb8ef;"
                    v-on="on"
                  >
                    mdi-robot
                  </v-icon>
                </template>
                {{ $t('bots.tradingBot') }}
              </v-tooltip>
             
             
              <br>
              <span class="name">{{ item.project.name }}</span>
              <br>
              <span
                class="since"
              >{{ $t('globals.added') }} {{ item.created_at | moment("from", "now") }}</span>
            </template>
            <template v-slot:item.aum="{ item }">
              <b class="aum">
                {{ item.project.base_currency | renderSymbol }}
                {{ item.aum }}
              </b>
            </template>
            <template v-slot:item.investors="{ item }">
              <b class="investors">{{ item.connected_investor_accounts }}</b>
            </template>
            <template v-slot:item.roi="{ item }">
              <div class="roi">
                <span :class="colorPnL(item.roi)">
                  <b>{{ item.roi }}%</b>
                </span>
              </div>
            </template>
            <template v-slot:item.risk="{ item }">
              <div
                v-if="item.project.status == 'active'"
                class="risk"
              >
                <v-icon
                  v-for="(risk, i) in [1,2,3]"
                  
                  :key="i"
                >
                  {{ item.risk_factor >= risk ? 'mdi-circle ' : 'mdi-circle-outline' }}
                </v-icon>
              </div>
              <v-tooltip
                v-if="item.project.status == 'incubation'"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    class="incubation"
                    v-on="on"
                  >
                    mdi-eye-outline
                  </v-icon>
                </template>
                {{ $t('rankings.testRisk') }}
              </v-tooltip>
            </template>
            <template v-slot:item.mindeposit="{ item }">
              <div>
                {{ item.project.base_currency | renderSymbol }}
                <b>{{ item.project.mindeposit }}</b>
              </div>
            </template>
            <template v-slot:item.pnl_chart="{ item }">
              <pnl-small-chart
                :ranking-id="item.id"
                :style="`width:180px`"
              />
            </template>
            <template v-slot:item.actions="{ }">
              <base target="_parent">
              <a
                :href="`/register`"
              >
                <v-btn
                  class="ma-1 join"
                  text
                  outlined
                >
                  {{ $t("rankings.joinButton") }}
                </v-btn>
              </a>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="rankings && (viewStyle == 1 || $vuetify.breakpoint.xs)"
      wrap
    >
      <v-flex
        v-for="(ranking) in rankings.data"
        :key="ranking.id"
        xs12
        md4
      >
        <v-card
          class="bot-card"
        >
          <v-layout
            wrap
            mb-1
            pt-2
            align-center
          >
            <v-flex
              xs2
              pl-4
            >
              <router-link :to="'/ranking/'+ranking.id">
                <v-avatar
                  v-if="ranking.project.logo !== null"
                  :tile="false"
                  class="avatar"
                  :size="$vuetify.breakpoint.xs ? '45' : '55'"
                >
                  <v-img
                    :src="ranking.project.logo"
                    :lazy-src="ranking.project.logo"
                    max-height="55"
                    contain
                  />
                </v-avatar>
                <v-avatar
                  v-else
                  class="avatar"
                  style="pointer: cursor;"
                  :tile="false"
                  :size="$vuetify.breakpoint.xs ? '45' : '55'"
                  color="#eceff1"
                >
                  <strong
                    class="avatar-invert"
                    style="font-size:16px;"
                  >{{ ranking.project.ticker | uppercase | substring(0,2) }}</strong>
                </v-avatar>
              </router-link>
            </v-flex>

            <v-flex
              xs7
            >
              <router-link :to="'/ranking/'+ranking.id">
                <b class="ticker">{{ ranking.project.ticker }}</b> 
              </router-link>
              <v-tooltip
                v-if="ranking.project.type == 'trading.copy'"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    style="margin: -5px 0px 0px 5px; font-size:18px;"
                    v-on="on"
                  >
                    mdi-alpha-c-circle-outline
                  </v-icon>
                </template>
                {{ $t('rankings.traderSupportCopy') }}
              </v-tooltip>
              <v-tooltip
                v-if="ranking.project.project_type == 'bot'"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    style="margin: -7px 0px 0px 4px; font-size:18px; color:#bcb8ef;"
                    v-on="on"
                  >
                    mdi-robot
                  </v-icon>
                </template>
                {{ $t('bots.tradingBot') }}
              </v-tooltip><br>
              <span class="name">{{ ranking.project.name }}</span>
            </v-flex>
            <v-flex
              xs3
              data
              small-icon
            >
              <span class="ml-1">{{ $t('globals.risk') }}</span>
              <div
                v-if="ranking.project.status == 'active'"
                class="risk"
              >
                <v-icon
                  v-for="(risk, i) in [1,2,3]"
                  
                  :key="i"
                >
                  {{ ranking.risk_factor >= risk ? 'mdi-circle ' : 'mdi-circle-outline' }}
                </v-icon>
              </div>
              <v-tooltip
                v-if="ranking.project.status == 'incubation'"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    class="incubation"
                    v-on="on"
                  >
                    mdi-eye-outline
                  </v-icon>
                </template>
                {{ $t('rankings.testRisk') }}
              </v-tooltip>
            </v-flex>
          </v-layout>
          <v-divider />
          <v-layout
            wrap
            mt-3
          >
            <v-flex
              xs6
              roi
              data
              :class="!$vuetify.breakpoint.xs ? 'pl-9': 'pl-4'"
            >
              <span>{{ $t('globals.roi') }}</span>
              <p :class="colorPnL(ranking.roi)">
                {{ ranking.roi }}%
              </p>
            </v-flex>
            <v-flex
              xs6
              :class="!$vuetify.breakpoint.xs ? 'pl-5': 'pl-1'"
            >
              <pnl-small-chart
                :ranking-id="ranking.id"
              />
            </v-flex>
          </v-layout>
         
         
          <v-layout
            wrap
            class="data"
          >
            <v-flex
              v-if="!$vuetify.breakpoint.xs"
              xs4
              pl-10
            >
              <span>{{ $t('globals.minDeposit') }}</span>
              <p>{{ ranking.project.mindeposit }}</p> 
            </v-flex>
            <v-flex
              :class="!$vuetify.breakpoint.xs ? 'xs4': 'xs6'"
              pl-5
            >
              <span>{{ $t('globals.investors') }}</span>
              <p>
                {{ ranking.connected_investor_accounts }}
              </p>
            </v-flex>
            <v-flex :class="!$vuetify.breakpoint.xs ? 'xs4': 'xs6'">
              <span>{{ $t('globals.aum') }}</span>
              <p class="text-primary">
                {{ ranking.project.base_currency | renderSymbol }}
                {{ ranking.aum }}
              </p>
            </v-flex>
          </v-layout>
          <v-divider />
          <v-card-actions class="mt-2 pr-0">
            <v-spacer />
            <base target="_parent">
            <a
              :href="`/register`"
            >
              <v-btn
                text
                outlined
                @click="$router.push(`/ranking/${ranking.id}`)"
              >
                {{ $t('rankings.joinButton') }}
              </v-btn>
            </a>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout> 
  </v-container>
</template>

<script>

(function() {
  function onTidioChatApiReady() {
    window.tidioChatApi.display(false);
  }
  if (window.tidioChatApi) {
    window.tidioChatApi.on("ready", onTidioChatApiReady);
  } else {
    document.addEventListener("tidioChat-ready", onTidioChatApiReady);
  }
})();

import RANKINGS_QUERY from "@/graphql/queries/Rankings.gql";
import PnlSmallChart from "@/views/Rankings/partial/PnLSmallChart.vue";
import infiniteScroll from 'vue-infinite-scroll'
import { mapGetters, mapMutations } from "vuex";


export default {
  name: "RankingList",
  directives: {
    infiniteScroll
  },
  components: {
    PnlSmallChart
  },
  data() {
    return {
      loading: false,
      viewStyle: 0,
      params: {
        page: 1,
        count: 6
      },
      headers: [
        {
          sortable: false,
          text: "",
          value: "logo"
        },
        {
          sortable: false,
          text: this.$t("globals.ticker"),
          value: "ticker"
        },
        {
          sortable: false,
          text: this.$t("globals.aum"),
          value: "aum"
        },
        {
          sortable: false,
          text: this.$t("globals.investors"),
          value: "investors"
        },
        {
          sortable: false,
          text: this.$t("globals.roi"),
          value: "roi"
        },
        {
          sortable: false,
          text: this.$t("globals.risk"),
          value: "risk"
        },
        // {
        //   sortable: false,
        //   text: this.$t("globals.minDeposit"),
        //   value: "mindeposit"
        // },
        {
          sortable: false,
          text: this.$t("rankings.pnlChart30"),
          value: "pnl_chart"
        },
        {
          sortable: false,
          text: '',
          value: "actions"
        }
      ]
    };
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
  },
  watch: {
    viewStyle(val, oldVal) {
      this.$ls.set("ranking_view", val);
    }
  },
  mounted() {
    if (
      this.$route.params.id !== undefined &&
      this.$route.params.id.length === 10
    ) {
      this.$cookie.set("sp", this.$route.params.id, { expires: "1M" });
    }
    if (this.rankings) {
      this.params.page = this.rankings.current_page
    }
    this.viewStyle = this.$route.query.v ? this.$route.query.v : this.$ls.get('ranking_view')
  },
  methods: {
    ...mapMutations("app", ["setShowChat"]),
  },
  apollo: {
    rankings: {
      query: RANKINGS_QUERY,
      fetchPolicy: 'network',
      variables() {
        return this.params
      },
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/styles/material-dashboard/_variables.scss";
.small-icon {
  .v-icon {
    margin-left: 4px;
    font-size: 16px;
  }
}
.rankings {
  th {
    .v-icon {
      margin-left: 4px;
      font-size: 16px;
    }
  }
  td {
    font-weight: 600;
    font-size: 17px;
  }
  .rank {
    font-size: 14px;
  }
  .ticker {
    font-weight: 700;
    color: $brand-primary;
    font-size: 16px;
  }
  .name {
    font-weight: 600;
    font-size: 15px;
    color: #7f97ab;
  }
  .since {
    font-weight: 200;
    font-size: 11px;
    color: #1b1b1b;
    display: block;
  }
  .aum {
    width: 180px;
    font-weight: 700;
    color: $brand-primary;
  }
  .investors {
    width: 100px;
  }
  .roi {
    width: 100px;
  }
  .incubation { 
    color: #a9a6d6;
    margin-left:7px;
  }
  .risk {
    i {
      color: #a9a6d6;
      font-size:14px;
    }
  }
  .insurance {
    width: 90px;
    font-weight: 200;
  }
  .actions {
    width: 110px;
  }
  .v-avatar {
    margin: 18px 0;
  }
}
</style>
